import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  tabsText: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
  },
}));
